import { render, staticRenderFns } from "./AdminAcademies.vue?vue&type=template&id=aab769e8&scoped=true&lang=pug&"
import script from "./AdminAcademies.vue?vue&type=script&lang=ts&"
export * from "./AdminAcademies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab769e8",
  null
  
)

export default component.exports